import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import RangeSlider from './RangeSlider';
import type WithClassName from './WithClassName';

function MPG({ className }: WithClassName) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const [show, setShow] = useState(false);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-mpg"
      facetContent={facetData.mpg}
      facetName="MPG"
      show={show}
      onToggle={() => setShow(v => !v)}
    >
      <RangeSlider
        className="px-24 py-32"
        isShowing={show}
        id="facet-mpg"
        label="MPG/MPGe"
        dualRange
        min={facetData.mpg?.min}
        max={facetData.mpg?.max}
        initialValues={[
          appliedFilters.mpg?.min ?? facetData.mpg?.min ?? 0,
          appliedFilters.mpg?.max ?? facetData.mpg?.max ?? 0
        ]}
        onUpdate={v => {
          updateRangeFilter({
            filterKey: 'mpg',
            value: {
              min: v?.[0] ?? facetData.mpg?.min,
              max: v?.[1] ?? facetData.mpg?.max
            }
          });
          trackEvent('Filter MPG range', {
            min: v?.[0] ?? facetData.mpg?.min,
            max: v?.[1] ?? facetData.mpg?.max
          });
        }}
        inputWidth="80px"
        labelTextTransform="none"
      />
    </FilterDrawer>
  );
}

export default MPG;
